<nz-footer>
  <div class="footer">
    <div class="footer-links" *transloco="let t">
      <a [href]="legalLinks.imprint" target="_blank">{{ t('footer.imprint') }}</a>
      <a [href]="legalLinks.dataProtection" target="_blank">{{
          t('footer.dataProtection')
        }}</a>
    </div>
    <div class="footer-app-version">
      <span>Frontend: v{{ frontendVersion }}</span>
      <span>©{{ currentYear }} Kerberos Compliance</span>
    </div>
  </div>
</nz-footer>
